<template>
  <div class="mt-15">
    <div class="tixstock-trending-categories-heading"></div>
    <div class="tixstock-tags-skeleton">
      <div
        v-for="index in 12"
        :key="index"
        class="tixstock-tag-skeleton"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonTixstockTrendingCategories'
}
</script>

<style scoped>
.tixstock-tags-skeleton {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  width: 100%;
}

.tixstock-tag-skeleton {
  height: 32px;
  background: #e0e0e0;
  border-radius: 6px;
  animation: pulse 1.5s infinite;
}

.tixstock-trending-categories-heading {
  height: 24px;
  width: 200px;
  background: #e0e0e0;
  border-radius: 4px;
  margin: 0 0 14px 8px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    background-color: #f0f0f0;
  }
  50% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #f0f0f0;
  }
}

@media (max-width: 992px) {
  .tixstock-tags-skeleton {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
}

@media (max-width: 576px) {
  .tixstock-tags-skeleton {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .tixstock-tag-skeleton {
    height: 28px;
  }
}

</style>